<div class="page-wrapper section-hr-direct">

    <app-multi-lingual></app-multi-lingual>
    <div class="new-login-container">
        <div class="tab-content">
 {{'RegistrationSuccess.Message'|translate}}
 <a  [routerLink]="['/login']"class="btn btn-main">{{'ForgotPassword.BackLogin'| translate}}</a>
                        
        </div>
    </div>
</div>
<app-outer-footer></app-outer-footer>